import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';
import { CartOperation } from '../enums/cartOperation';

declare const window: any;

export const mcpCustomWrapperApi = createApi({
    reducerPath: 'mcpCustomWrapperApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_CUSTOM_WRAPPER ?? "https://npr-custom-wrapper.api.pens.com/",
        prepareHeaders: (headers) => {
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS_2 ?? "lhXAR4He7J1NcGOC22zZN95xaz8hmXah9iCJESHs")
            return headers
        },
    }),
    tagTypes: ['mcpCustomWrapper'],
    endpoints: (builder) => ({
        updateMcpAnonymousId: builder.mutation({
                    async queryFn({data}, {dispatch, getState}, _extraOptions,  baseQuery) {
                        const response:any = await baseQuery({ url: `v1/updatemcpanonymousid`,
                            method: 'POST',
                            body: data,
                        });
                        return response;
                    },
                    async onQueryStarted(args, { dispatch, queryFulfilled }) {
                        try {
                            const { data } = await queryFulfilled;
                            return data; 
                        }
                        catch (error) {
                            dispatch(onErrorHandler({operation: CartOperation.UPDATE_ANONYMOUS_ID, err: JSON.stringify(error), errMsg: 'Error: while updating mcp anonymous id', api: `v1/updatemcpanonymousid`}));     
                        }
                    }
                }),
    }),
})

export const {useUpdateMcpAnonymousIdMutation} = mcpCustomWrapperApi;

